module.exports = __webpack_public_path__ + "static/media/parking_libero.51e7c1e4.svg";